<!--Navbar-->
<header class="fixed-top" aria-label="Header">
  <pmd-navbar class="navbar-expand-xl pmd-z-depth-4 navbar-light bg-white">
    <div class="container-fluid">
      <pmd-navbar-brand>
        <a tabindex="0" class="navbar-brand" routerLink="/login" aria-label="Probanker Logo">
          <img
            src="assets/images/probanker-logo.svg"
            width="200"
            height="32"
            class="d-inline-block align-center"
            alt="Probanker Logo"
          />
        </a>
      </pmd-navbar-brand>
      <!-- <pmd-navbar-right-icon>
                <form class="ms-auto">
                    <app-language></app-language>
                </form>
            </pmd-navbar-right-icon> -->
    </div>
  </pmd-navbar>
</header>
<!--/.Navbar-->

<!--Main Content Area-->
<main aria-label="Main Content" class="pmd-content">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</main>

<footer aria-label="Footer">
  <app-footer class="login-app-footer"></app-footer>
</footer>
<!--/.Main Content Area-->
